(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/player-constants.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/player-constants.js');

'use strict';

var extraButtonActions = {
  HIDE_EXTRA_BUTTON_ON_FULLSCREEN: 'hideExtraButtonOnFullScreen'
};
var controlBar = {
  children: ['empLiveDisplay', 'volumePanel', 'progressControl', 'fullscreenToggle']
};
var constants = {
  extraButtonActions: extraButtonActions,
  controlBar: controlBar
};
svs.components.emp_video_player.helpers.constants = constants;

 })(window);